import { useMutation, useQueryClient } from '@tanstack/react-query';

import type Link from '@monetr/interface/models/Link';
import request from '@monetr/interface/util/request';

export function useRemoveLink(): (_linkId: string) => Promise<unknown> {
  const queryClient = useQueryClient();

  async function removeLink(linkId: string): Promise<string> {
    return await request({ method: 'DELETE', url: `/api/links/${linkId}` }).then(() => linkId);
  }

  const mutate = useMutation({
    mutationFn: removeLink,
    onSuccess: (linkId: string) =>
      Promise.all([
        queryClient.setQueryData(['/api/links'], (previous: Array<Partial<Link>>) =>
          previous.filter(item => item.linkId !== linkId),
        ),
        queryClient.removeQueries({ queryKey: [`/api/links/${linkId}`] }),
      ]),
  });

  return mutate.mutateAsync;
}
